import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import { SVGStyled } from '../shared';

/**
 * Base SVG "Fill" component
 *
 * @param props.as defaults to "path"; any valid SVG child element can be used.
 * @param props.svgColor fill color (if not set, relies on value from context)
 */
var SVGFill = SVGStyled.path(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fill: ", ";\n"])), function (_ref) {
  var svgColor = _ref.svgColor,
      theme = _ref.theme;
  return svgColor || theme.svgColor;
});
SVGFill.defaultProps = {
  role: 'presentation'
};
export default SVGFill;